/**
 * Canonical length-prefixed byte encoding.
 *
 * Concatenating two byte strings with a single separator (e.g. ':') is NOT an
 * injective encoding — {a:, b} and {a, :b} produce the same output. All
 * cryptographic scopes (pseudonym, tracking_ID, campaign_ref, DLEQ challenges)
 * MUST use length-prefixed concatenation so each input chunk is unambiguously
 * recoverable.
 *
 * @traces F-H2 (canonical encoding), R4.1, R4.2, R10.2
 */
/**
 * Concatenate `chunks`, each prefixed with its big-endian uint32 length.
 *
 * Example: [<0xAA>, <0xBB 0xCC>] → <0x00 0x00 0x00 0x01 0xAA 0x00 0x00 0x00 0x02 0xBB 0xCC>
 */
export function lengthPrefixedConcat(chunks) {
    const total = chunks.reduce((n, c) => n + 4 + c.length, 0);
    const out = new Uint8Array(total);
    let off = 0;
    const view = new DataView(out.buffer);
    for (const c of chunks) {
        view.setUint32(off, c.length, false);
        off += 4;
        out.set(c, off);
        off += c.length;
    }
    return out;
}
/** Encode a string as UTF-8 bytes (convenience wrapper). */
export function utf8(s) {
    return new TextEncoder().encode(s);
}
